import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./EventBooking.css";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import { ShowEvents } from "../../../../context/Slice/EventManagementSlice";
import { ShowAllUsers } from "../../../../context/Slice/RegisterSlice";
import { ShowAllCategories } from "../../../../context/Slice/VendorManagementSlice";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AddBookingPopup = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    client_Name: "",
    client_Email: "",
    mobile_no: "",
    event_Type: "",
    vendor_Category: "",
    vendor_Name: "",
    vendor_Mobile: "",
    start_Date: "",
    end_Date: "",
    guests: "",
    total_Amount: "",
    advance_Paid: "",
    booking_Date: new Date().toISOString().split("T")[0] || "",
    upload_Payment_Screenshot: null,
    payment_Method: "Cash",
    payment_Date: new Date().toISOString().split("T")[0] || "",
  });
  const [filteredVendors, setFilteredVendors] = useState([]);

  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [events, setEvents] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vendorMobile, setVendorMobile] = useState([]);
  const token = secureLocalStorage.getItem("token");
  const [filteredData, setFilteredData] = useState([]);

  // Fetch events data
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const ID = decoded._id;
        dispatch(ShowEvents(ID)).then((response) => {
          if (response.payload && response.payload.events) {
            setEvents(response.payload.events);
          }
        });
      } catch (error) {
        console.error("Token decoding failed:", error);
      }
    }
  }, [dispatch, token]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/v1/VendorManagement/show-AllVendorService`
        );
        const fetchedData = response.data.data.allVendorService;
        console.log("Fetched Data:", fetchedData); // Log the fetched data

        const vendorMobileObject = fetchedData.reduce((acc, vendor) => {
          const fullName = `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`;
          acc[fullName] = vendor.Vendor.mobile_number;
          return acc;
        }, {});

        const Categories = [
          ...new Set(fetchedData.map((data) => data.ServiceName)),
        ];

        const filteredData = fetchedData.filter((data) =>
          Categories.includes(data.ServiceName)
        );

        setFilteredData(filteredData);

        setVendors(
          filteredData.map(
            (vendor) => `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`
          )
        );
        setVendorMobile(vendorMobileObject);

        setCategories(Categories);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // console.log(vendors);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "client_Name") {
      console.log("Name of the client: ", value);

      const selectedClient = events.find(
        (event) => `${event.User.firstName} ${event.User.lastName}` === value
      );

      console.log("Selected Client: ", selectedClient);

      if (selectedClient) {
        const vendors = selectedClient.Event_Vendors || [];
        console.log("Vendors: ", vendors);

        const vendorCategory =
          vendors.length > 0
            ? vendors
                .map((vendor) => vendor.Budget?.categories[0]?.type || "N/A")
                .join(", ")
            : selectedClient.Budget?.categories.map(
                (category) => category.type
              ) || "N/A";

        // Reset vendor-related fields when changing client
        setFormData((prev) => ({
          ...prev,
          client_Email: selectedClient.User.email,
          event_Type: selectedClient.EventName,
          mobile_no: selectedClient.User.mobile_number,
          start_Date: selectedClient.Start_Date || "",
          end_Date: selectedClient.End_Date || "",
          guests: selectedClient.Guest || "",
          vendor_Name: "",
          vendor_Mobile: "",
          vendor_Category: vendorCategory,
          total_Amount: selectedClient.Budget.estimatedBudget,
        }));
      } else {
        console.log("No client found for the given name.");
      }
    }

    if (name === "vendor_Category") {
      console.log(value);
      console.log(filteredData);
      const selectedCategory = value;

      const vendorsForCategory = filteredData.filter(
        (vendor) => vendor.ServiceName === selectedCategory
      );

      console.log(vendorsForCategory);
      setFilteredVendors(vendorsForCategory);
    }

    if (name === "vendor_Name") {
      const selectedVendor = filteredVendors.find(
        (vendor) =>
          `${vendor.Vendor.firstName} ${vendor.Vendor.lastName}` === value
      );

      setFormData((prev) => ({
        ...prev,
        vendor_Name: value,
        vendor_Mobile: selectedVendor
          ? selectedVendor.Vendor.mobile_number
          : "",
      }));
    }
  };

  console.log("Form event=>", events);
  console.log("Form event=>", formData);

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the selected file
    setFormData((prev) => ({
      ...prev,
      upload_Payment_Screenshot: file, // Update the state with the file
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = secureLocalStorage.getItem("token");

      // Prepare form data for the API
      const data = new FormData();
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      // API call
      const response = await axios.post(
        `${BASE_URL}/api/v1/CoordinatorManagement/Add-Event-Booking-Management`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Handle success
      if (response.status === 200) {
        alert("Booking added successfully!");
        onSubmit(formData);
        onClose();
        // window.location.reload();
      } else {
        alert("Failed to add booking. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting booking:", error);
      alert("An error occurred while adding the booking. Please try again.");
    }
  };

  return (
    <div className="popup-container">
      <div className="popup">
        <h3>Add New Booking</h3>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Client Name:</label>
            <select
              name="client_Name"
              value={formData.client_Name}
              onChange={handleChange}
              required
            >
              <option value="">Select Client</option>
              {events.map((event) => (
                <option
                  key={event.id}
                  value={`${event.User.firstName} ${event.User.lastName}`}
                >
                  {event.User.firstName} {event.User.lastName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Email:</label>
            <input
              type="text"
              name="client_Email"
              value={formData.client_Email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Mobile:</label>
            <input
              type="text"
              name="mobile_no"
              value={formData.mobile_no}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Event Type:</label>
            <input
              type="text"
              name="event_Type"
              value={formData.event_Type}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Start Date:</label>
            <input
              type="text"
              name="start_Date"
              value={formData.start_Date}
              readOnly
            />
          </div>

          <div>
            <label>End Date:</label>
            <input
              type="text"
              name="end_Date"
              value={formData.end_Date}
              readOnly
            />
          </div>

          <div className="single-row">
            <label>Vendor Category</label>
            <select
              name="vendor_Category"
              value={
                formData.vendor_Category &&
                categories.includes(formData.vendor_Category)
                  ? formData.vendor_Category
                  : ""
              }
              onChange={handleChange}
            >
              <option value="">Select Category</option>{" "}
              {/* Ensures default selection */}
              {Array.isArray(categories) && categories.length > 0 ? (
                categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category}
                  </option>
                ))
              ) : (
                <option value="N/A">N/A</option>
              )}
            </select>
          </div>

          <div>
            <label>Vendor Name</label>
            <select
              name="vendor_Name"
              value={formData.vendor_Name || "Select Vendor"}
              onChange={(e) => {
                const selectedName = e.target.value;

                const selectedVendor = filteredData.find(
                  (data) =>
                    `${data.Vendor.firstName} ${data.Vendor.lastName}` ===
                    selectedName
                );

                // Ensure selectedVendor is not undefined before accessing properties
                const SelectedVendorId = selectedVendor
                  ? selectedVendor.Vendor_ID
                  : "";
                const vendorMobile = selectedVendor
                  ? selectedVendor.Vendor.mobile_number
                  : "";

                console.log(SelectedVendorId);
                // console.log(vendorMobile);

                setFormData({
                  ...formData,
                  vendor_Name: selectedName,
                  vendor_Mobile: vendorMobile,
                  vendor_ID: SelectedVendorId,
                });
              }}
            >
              <option value="Select Vendor">Select Vendor</option>
              {filteredVendors.length > 0 ? (
                filteredVendors.map((vendor, index) => (
                  <option
                    key={index}
                    value={`${vendor.Vendor.firstName} ${vendor.Vendor.lastName}`}
                  >
                    {vendor.Vendor.firstName} {vendor.Vendor.lastName}
                  </option>
                ))
              ) : (
                <option value="N/A">No Vendors Available</option>
              )}
            </select>
          </div>

          <div>
            <label>Vendor Mobile:</label>
            <input
              type="text"
              name="vendor_Mobile"
              value={formData.vendor_Mobile || ""}
              onChange={handleChange}
              readOnly
            />
          </div>

          <div>
            <label>Guest Count</label>
            <input
              type="text"
              name="guests"
              value={formData.guests}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Total Amount:</label>
            <input
              type="number"
              name="total_Amount"
              value={formData.total_Amount}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Advance Paid:</label>
            <input
              type="number"
              name="advance_Paid"
              value={formData.advance_Paid}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label>Booking Date:</label>
            <input
              type="date"
              name="booking_Date"
              value={formData.booking_Date}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>

          <div>
            <label>Payment Method:</label>
            <select
              name="payment_Method"
              value={formData.payment_Method}
              onChange={handleChange}
            >
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="credit-card">Credit Card</option>
              <option value="bank-transfer">Bank Transfer</option>
            </select>
          </div>

          {/* Conditionally render the Upload Payment Screenshot field */}
          {(formData.payment_Method === "upi" ||
            formData.payment_Method === "credit-card" ||
            formData.payment_Method === "bank-transfer") && (
            <div className="single-row">
              <label>Upload Payment Screenshot:</label>
              <input
                type="file"
                name="upload_Payment_Screenshot"
                onChange={handleFileChange}
              />
            </div>
          )}

          <div>
            <label>Payment Date:</label>
            <input
              type="date"
              name="payment_Date"
              value={formData.payment_Date} // Set default to current date
              min={new Date().toISOString().split("T")[0]}
              onChange={handleChange}
            />
          </div>

          <div className="popup-actions">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
      <div className="popup-overlay" onClick={onClose}></div>
    </div>
  );
};

const EventBooking = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [popupBooking, setPopupBooking] = useState(null);
  const [bookings, setBookings] = useState([]);
  const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your actual base URL
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId"); // Use getItem instead of get

  useEffect(() => {
    const fetchAllBookings = async () => {
      try {
        const token = localStorage.getItem("token");

        // Fetch both API responses in parallel
        const [response1, response2] = await Promise.all([
          axios.get(
            `${BASE_URL}/api/v1/CoordinatorManagement/admin/Get-Event-Booking-Management`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
          axios.get(
            `${BASE_URL}/api/v1/CoordinatorManagement/get-Event-Booking-Management`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          ),
        ]);

        // Extract data from responses
        const data1 = response1.data.data.getAllEventBookingManagement || [];
        const data2 = response2.data.data || [];

        // ✅ Process data1 (response1)
        const formattedData1 = data1.map((item) => ({
          ...item,
          data: { ...item.data, isUsed: item.isUsed }, // Move `isUsed` inside `data`
        }));


        // ✅ Process data2 (response2)
        const formattedData2 = data2.map((item) => {
          const parsedData = JSON.parse(item.data); // Convert `data` from string to object
          return {
            ...item,
            data: { ...parsedData, isUsed: item.isUsed }, // Move `isUsed` inside `data`
          };
        });

        const formdata2 = formattedData2.map((data) => data.data);

        // ✅ Merge both data arrays
        const mergedData = [...formattedData1, ...formdata2];

        // ✅ Sort by client name (if exists)
        mergedData.sort((a, b) => {
          // Sort `isUsed: false` first
          if ((a.data?.isUsed === false || a.isUsed === false) && (b.data?.isUsed !== false && b.isUsed !== false)) {
            return -1; // `a` comes first
          }
          if ((b.data?.isUsed === false || b.isUsed === false) && (a.data?.isUsed !== false && a.isUsed !== false)) {
            return 1; // `b` comes first
          }
          // If both have the same `isUsed` status, sort by `client_Name`
          return a.data?.client_Name?.localeCompare(b.data?.client_Name) || 0;
        });
        


        // ✅ Filter data based on `co_ordinator_id`
        const filteredData = mergedData.filter((item) => {
          const coordinatorId =
            item.data?.co_ordinator_id || item.co_ordinator_id;
          return Number(coordinatorId) === Number(userId);
        });

        // console.log("Filtered Data:", filteredData);

        // ✅ Set the final data in state
        setBookings(filteredData);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };

    fetchAllBookings();
  }, []); // Only runs once on mount

  console.log(bookings);

  const filteredBookings = bookings.filter((booking) => {
    if (!booking) {
      console.warn("Warning: booking.data is undefined", booking);
      return false; // Skip undefined data
    }

    const clientNameMatch =
      booking.client_Name &&
      booking.client_Name.toLowerCase().includes(searchTerm.toLowerCase());

    const eventNameMatch =
      booking.event_Type &&
      booking.event_Type.toLowerCase().includes(searchTerm.toLowerCase());

    const vendorNameMatch =
      booking.vendor_Name &&
      booking.vendor_Name.toLowerCase().includes(searchTerm.toLowerCase());

    return clientNameMatch || eventNameMatch || vendorNameMatch;
  });

  const handleAddBooking = (newBooking) => {
    setBookings((prevBookings) => [...prevBookings, newBooking]);
  };

  const handlePopupClose = () => {
    setPopupBooking(null);
  };
  const HandleBack = () => {
    navigate("/co-ordinator-dashboard");
  };

  return (
    <div id="EventBooking">
      <div>
        <Button
          variant="contained"
          color="secondary"
          onClick={HandleBack}
          sx={{ position: "absolute", top: "20px", left: "20px" }}
        >
          Back
        </Button>
        <h2 className="heading">Event Booking Management</h2>
        <div className="searchField">
          <input
            type="text"
            placeholder="Search by Client, Event, or Vendor Name"
            className="searchInput"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="btn-addBooking">
            <button
              className="btn btn-primary"
              onClick={() => setPopupBooking({})}
            >
              Add a Booking
            </button>
          </div>
        </div>
      </div>
      <div className="table-container">
        <table className="event-booking-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Client Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Event Type</th>
              <th>Vendor Category</th>
              <th>Vendor Name</th>
              <th>Vendor Mobile</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Booking Date</th>
              <th>Guests</th>
              <th>Total Amount</th>
              <th>Advance Paid</th>
              <th>Remaining Amount</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredBookings.length > 0 ? (
              filteredBookings.map((booking, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{booking?.client_Name || "N/A"}</td>
                  <td>{booking?.client_Email || "N/A"}</td>
                  <td>{booking?.mobile_no || "N/A"}</td>
                  <td>{booking?.event_Type || "N/A"}</td>
                  <td>{booking?.vendor_Category || "N/A"}</td>
                  <td>{booking?.vendor_Name || "N/A"}</td>
                  <td>{booking?.vendor_Mobile || "N/A"}</td>
                  <td>{moment(booking.start_Date).format("DD/MM/YYYY")}</td>
                  <td>{moment(booking.end_Date).format("DD/MM/YYYY")}</td>
                  <td>{moment(booking.booking_Date).format("DD/MM/YYYY")}</td>
                  <td>{booking?.guests || "N/A"}</td>
                  <td>
                    ₹{booking?.total_Amount || 0} <br />
                    <small>{booking?.total_Amount_Description}</small>
                  </td>
                  <td>
                    ₹{booking?.advance_Paid || 0} <br />
                    <small>{booking?.Advance_Description}</small>
                  </td>
                  <td>
                    ₹
                    {(booking?.total_Amount || 0) -
                      (booking?.advance_Paid || 0)}
                  </td>
                  <td>
                    <span
                      style={{
                        backgroundColor:
                          booking.isUsed == null || booking.isUsed
                            ? "lightgreen"
                            : "lightcoral",
                        color:
                          booking.isUsed == null || booking.isUsed
                            ? "green"
                            : "red",
                        padding: "2px 6px",
                        borderRadius: "4px",
                      }}
                    >
                      {booking.isUsed == null || booking.isUsed
                        ? "Approved"
                        : "Pending"}
                    </span>
                  </td>
                  <td
                    colSpan="2"
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    {(booking?.data?.isUsed === false ||
                      booking?.isUsed === false) && (
                      <button
                        style={{
                          backgroundColor: "#007bff",
                          color: "white",
                          border: "none",
                          padding: "4px 12px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "11px",
                        }}
                      >
                        Resend Token
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="13" className="text-center py-4">
                  No bookings found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {popupBooking && (
        <AddBookingPopup
          onClose={handlePopupClose}
          onSubmit={handleAddBooking}
        />
      )}
    </div>
  );
};

export default EventBooking;
